var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoParetoChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_basic_column",
    transform: "translate(-65 -9.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 32,
    height: 32,
    transform: "translate(65 9.688)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ico_basic_column-2",
    "data-name": "ico_basic_column",
    transform: "translate(65.629 -103.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53965",
    "data-name": "Path 53965",
    d: "M155.123,240h-3.6a.89.89,0,0,0-.9.884V255.1a.89.89,0,0,0,.9.884h3.6a.89.89,0,0,0,.9-.884V240.885A.89.89,0,0,0,155.123,240Z",
    transform: "translate(-141.554 -113.487)",
    fill: "#06c270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53966",
    "data-name": "Path 53966",
    d: "M275.623,200.352h-3.6a.9.9,0,0,1-.9-.91v-8.782a.9.9,0,0,1,.9-.91h3.6a.9.9,0,0,1,.9.91v8.782A.9.9,0,0,1,275.623,200.352Z",
    transform: "translate(-254.851 -57.853)",
    fill: "#00cfde"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53966-2",
    "data-name": "Path 53966",
    d: "M275.623,199.851h-3.6a.9.9,0,0,1-.9-.91v-18.28a.9.9,0,0,1,.9-.91h3.6a.9.9,0,0,1,.9.91v18.28A.9.9,0,0,1,275.623,199.851Z",
    transform: "translate(-269.255 -57.352)",
    fill: "#36adfc",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53967",
    "data-name": "Path 53967",
    d: "M396.124,143.5h-3.6a.89.89,0,0,1-.9-.884v-23.23a.89.89,0,0,1,.9-.884h3.6a.89.89,0,0,1,.9.884v23.23A.89.89,0,0,1,396.124,143.5Z",
    transform: "translate(-368.149 -1.002)",
    fill: "#be88f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53969",
    "data-name": "Path 53969",
    d: "M197.552,240h-1.8v15.984h1.8a.89.89,0,0,0,.9-.884V240.885A.89.89,0,0,0,197.552,240Z",
    transform: "translate(-183.981 -113.486)",
    fill: "#019a57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53970",
    "data-name": "Path 53970",
    d: "M318.052,189.751h-1.8v10.6h1.8a.9.9,0,0,0,.9-.91v-8.782A.9.9,0,0,0,318.052,189.751Z",
    transform: "translate(-297.28 -57.853)",
    fill: "#06b1be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54009",
    "data-name": "Path 54009",
    d: "M318.052,179.751h-1.8v20.1h1.8a.9.9,0,0,0,.9-.91v-18.28A.9.9,0,0,0,318.052,179.751Z",
    transform: "translate(-311.683 -57.352)",
    fill: "#2174d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53971",
    "data-name": "Path 53971",
    d: "M438.552,118.5h-1.8v25h1.8a.89.89,0,0,0,.9-.884v-23.23A.89.89,0,0,0,438.552,118.5Z",
    transform: "translate(-410.577 -1.002)",
    fill: "#9665c7"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoParetoChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_pareto_chart.b155e94d3ef88e9addc8d166ac4911f8.svg";